import { useState } from "react"

export function useCollapsablePlugin({ isOpen, onClickCollapse }) {
  const [filterKey, setFilterKey] = useState('')

  const onToggleFilter = (e) => {
    if (!isOpen) {
      setFilterKey('filter')
    } else {
      e.stopPropagation()
      setFilterKey(filterKey === 'filter' ? '' : 'filter')
    }
  }

  const onToggleSearch = (e) => {
    if (!isOpen) {
      setFilterKey('search')
    } else {
      e.stopPropagation()
      setFilterKey(filterKey === 'search' ? '' : 'search')
    }
  }

  const onToggleCollapse = () => {
    if (isOpen) {
      setFilterKey('')
    }
    onClickCollapse()
  }

  return {
    filterKey,
    onToggleFilter,
    onToggleSearch,
    onToggleCollapse
  }
}

export default useCollapsablePlugin
